import { ScheduledDeliveryState, ScheduleType } from '../shared';
import type { ScheduledDelivery } from './types';

export const STUB_SCHEDULED_DELIVERIES: ScheduledDelivery[] = [
  {
    name: 'scheduledDeliveries/f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    uid: 'f1e2d3c4-b5a6-7890-abcd-ef1234567890',
    displayName: 'HSBC Daily Invoices',
    sourceLocation: '11111111-1111-1111-1111-111111111111',
    sourcePath: '/outbound/invoices/',
    targetLocation: '22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/invoices/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 2 * * *',
      timezone: 'America/Chicago',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T02:00:00Z',
    lastExecutionTime: '2024-01-15T02:00:00Z',
    createTime: '2024-01-01T10:00:00Z',
    updateTime: '2024-01-10T14:00:00Z',
  },
  {
    name: 'scheduledDeliveries/e2d3c4b5-a6f7-8901-bcde-f23456789012',
    uid: 'e2d3c4b5-a6f7-8901-bcde-f23456789012',
    displayName: 'SMBC EMEA Hourly Feedback',
    sourceLocation: '33333333-3333-3333-3333-333333333333',
    sourcePath: '/exports/',
    targetLocation: '44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 * * * *',
      timezone: 'Europe/London',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T04:00:00Z',
    lastExecutionTime: '2024-01-15T03:00:00Z',
    createTime: '2024-01-05T08:00:00Z',
    updateTime: '2024-01-12T11:00:00Z',
  },
  {
    name: 'scheduledDeliveries/d3c4b5a6-f7e8-9012-cdef-345678901234',
    uid: 'd3c4b5a6-f7e8-9012-cdef-345678901234',
    displayName: 'Truist Weekly Transactions',
    sourceLocation: '55555555-5555-5555-5555-555555555555',
    sourcePath: '/data/transactions/',
    targetLocation: '66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/transactions/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 6 * * 1',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_PAUSED,
    nextExecutionTime: undefined,
    lastExecutionTime: '2024-01-13T06:00:00Z',
    createTime: '2023-11-15T12:00:00Z',
    updateTime: '2024-01-14T09:00:00Z',
  },
  {
    name: 'scheduledDeliveries/c4b5a6f7-e8d9-0123-def0-456789012345',
    uid: 'c4b5a6f7-e8d9-0123-def0-456789012345',
    displayName: 'BBVA Catalog Sync',
    sourceLocation: '77777777-7777-7777-7777-777777777777',
    sourcePath: '/catalog/',
    targetLocation: '88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 4 * * *',
      timezone: 'Europe/Madrid',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T04:00:00Z',
    lastExecutionTime: '2024-01-15T04:00:00Z',
    createTime: '2024-02-01T10:00:00Z',
    updateTime: '2024-02-10T08:00:00Z',
  },
  {
    name: 'scheduledDeliveries/b5a6f7e8-d9c0-1234-ef01-567890123456',
    uid: 'b5a6f7e8-d9c0-1234-ef01-567890123456',
    displayName: 'Legacy Migration (Cancelled)',
    sourceLocation: '11111111-1111-1111-1111-111111111111',
    sourcePath: '/legacy/',
    targetLocation: '22222222-2222-2222-2222-222222222222',
    targetPath: '/migrated/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_RATE,
      expression: '30m',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_CANCELLED,
    lastExecutionTime: '2024-01-01T12:00:00Z',
    createTime: '2023-12-01T10:00:00Z',
    updateTime: '2024-01-02T14:00:00Z',
  },
  {
    name: 'scheduledDeliveries/a6f7e8d9-c0b1-2345-f012-678901234567',
    uid: 'a6f7e8d9-c0b1-2345-f012-678901234567',
    displayName: 'Santander Daily Statements',
    sourceLocation: '99999999-9999-9999-9999-999999999999',
    sourcePath: '/statements/*.csv',
    targetLocation: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    targetPath: '/inbound/statements/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 3 * * *',
      timezone: 'Europe/Madrid',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T03:00:00Z',
    lastExecutionTime: '2024-01-15T03:00:00Z',
    createTime: '2024-01-20T08:00:00Z',
    updateTime: '2024-02-20T10:00:00Z',
  },
  {
    name: 'scheduledDeliveries/b7e8f9a0-d1c2-3456-0123-789012345678',
    uid: 'b7e8f9a0-d1c2-3456-0123-789012345678',
    displayName: 'Wells Fargo Archive Sync',
    sourceLocation: '55555555-5555-5555-5555-555555555555',
    sourcePath: '/processed/*.xml',
    targetLocation: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    targetPath: '/archive/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 0 * * 0',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-21T00:00:00Z',
    lastExecutionTime: '2024-01-14T00:00:00Z',
    createTime: '2023-12-01T10:00:00Z',
    updateTime: '2024-02-15T14:30:00Z',
  },
  {
    name: 'scheduledDeliveries/c8f9a0b1-e2d3-4567-1234-890123456789',
    uid: 'c8f9a0b1-e2d3-4567-1234-890123456789',
    displayName: 'Citi Bank Reports Delivery',
    sourceLocation: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
    sourcePath: '/reports/*.pdf',
    targetLocation: '44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/reports/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '30 8 * * 1-5',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T08:30:00Z',
    lastExecutionTime: '2024-01-15T08:30:00Z',
    createTime: '2024-01-25T09:00:00Z',
    updateTime: '2024-02-18T11:00:00Z',
  },
  {
    name: 'scheduledDeliveries/d9a0b1c2-f3e4-5678-2345-901234567890',
    uid: 'd9a0b1c2-f3e4-5678-2345-901234567890',
    displayName: 'BNP Paribas Transaction Sync',
    sourceLocation: 'dddddddd-dddd-dddd-dddd-dddddddddddd',
    sourcePath: '/transactions/*.json',
    targetLocation: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
    targetPath: '/imports/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '*/15 * * * *',
      timezone: 'Europe/Paris',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_PAUSED,
    lastExecutionTime: '2024-02-22T09:15:00Z',
    createTime: '2024-02-05T08:00:00Z',
    updateTime: '2024-02-22T09:30:00Z',
  },
  {
    name: 'scheduledDeliveries/e0b1c2d3-a4f5-6789-3456-012345678901',
    uid: 'e0b1c2d3-a4f5-6789-3456-012345678901',
    displayName: 'Deutsche Bank Azure Backup',
    sourceLocation: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
    sourcePath: '/backup/*.bak',
    targetLocation: '66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/azure/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 1 * * *',
      timezone: 'Europe/Berlin',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T01:00:00Z',
    lastExecutionTime: '2024-01-15T01:00:00Z',
    createTime: '2024-01-10T14:00:00Z',
    updateTime: '2024-02-19T16:00:00Z',
  },
  {
    name: 'scheduledDeliveries/f1c2d3e4-b5a6-7890-4567-123456789012',
    uid: 'f1c2d3e4-b5a6-7890-4567-123456789012',
    displayName: 'Credit Suisse Daily Backup',
    sourceLocation: '10101010-1010-1010-1010-101010101010',
    sourcePath: '/data/*',
    targetLocation: '88888888-8888-8888-8888-888888888888',
    targetPath: '/backup/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 23 * * *',
      timezone: 'Europe/Zurich',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T23:00:00Z',
    lastExecutionTime: '2024-01-14T23:00:00Z',
    createTime: '2023-11-15T10:00:00Z',
    updateTime: '2024-02-10T12:00:00Z',
  },
  {
    name: 'scheduledDeliveries/02d3e4f5-c6b7-8901-5678-234567890123',
    uid: '02d3e4f5-c6b7-8901-5678-234567890123',
    displayName: 'UBS Trading Data Export',
    sourceLocation: '20202020-2020-2020-2020-202020202020',
    sourcePath: '/exports/*.parquet',
    targetLocation: '33333333-3333-3333-3333-333333333333',
    targetPath: '/imports/trading/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 */4 * * *',
      timezone: 'Europe/Zurich',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T12:00:00Z',
    lastExecutionTime: '2024-01-15T08:00:00Z',
    createTime: '2024-01-08T11:00:00Z',
    updateTime: '2024-02-21T13:45:00Z',
  },
  {
    name: 'scheduledDeliveries/13e4f5a6-d7c8-9012-6789-345678901234',
    uid: '13e4f5a6-d7c8-9012-6789-345678901234',
    displayName: 'JP Morgan Report Delivery',
    sourceLocation: '77777777-7777-7777-7777-777777777777',
    sourcePath: '/reports/*.xlsx',
    targetLocation: '30303030-3030-3030-3030-303030303030',
    targetPath: '/inbound/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 9 * * 1-5',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T09:00:00Z',
    lastExecutionTime: '2024-01-15T09:00:00Z',
    createTime: '2024-02-12T09:00:00Z',
    updateTime: '2024-02-23T10:30:00Z',
  },
  {
    name: 'scheduledDeliveries/24f5a6b7-e8d9-0123-7890-456789012345',
    uid: '24f5a6b7-e8d9-0123-7890-456789012345',
    displayName: 'Barclays Historical Archive',
    sourceLocation: '40404040-4040-4040-4040-404040404040',
    sourcePath: '/historical/*',
    targetLocation: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    targetPath: '/archive/barclays/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 2 1 * *',
      timezone: 'Europe/London',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-02-01T02:00:00Z',
    lastExecutionTime: '2024-01-01T02:00:00Z',
    createTime: '2023-10-20T14:00:00Z',
    updateTime: '2024-01-30T16:00:00Z',
  },
  {
    name: 'scheduledDeliveries/35a6b7c8-f9e0-1234-8901-567890123456',
    uid: '35a6b7c8-f9e0-1234-8901-567890123456',
    displayName: 'RBC Canada Data Sync',
    sourceLocation: '50505050-5050-5050-5050-505050505050',
    sourcePath: '/outbound/*.csv',
    targetLocation: '22222222-2222-2222-2222-222222222222',
    targetPath: '/inbound/rbc/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 5 * * *',
      timezone: 'America/Toronto',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-16T05:00:00Z',
    lastExecutionTime: '2024-01-15T05:00:00Z',
    createTime: '2024-01-18T08:00:00Z',
    updateTime: '2024-02-24T09:00:00Z',
  },
  {
    name: 'scheduledDeliveries/46b7c8d9-a0f1-2345-9012-678901234567',
    uid: '46b7c8d9-a0f1-2345-9012-678901234567',
    displayName: 'TD Bank Integration Sync',
    sourceLocation: '60606060-6060-6060-6060-606060606060',
    sourcePath: '/exchange/*',
    targetLocation: '44444444-4444-4444-4444-444444444444',
    targetPath: '/imports/td/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_RATE,
      expression: '1h',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T11:00:00Z',
    lastExecutionTime: '2024-01-15T10:00:00Z',
    createTime: '2024-02-08T10:00:00Z',
    updateTime: '2024-02-25T11:00:00Z',
  },
  {
    name: 'scheduledDeliveries/57c8d9e0-b1a2-3456-0123-789012345678',
    uid: '57c8d9e0-b1a2-3456-0123-789012345678',
    displayName: 'PNC Financial Reports',
    sourceLocation: '70707070-7070-7070-7070-707070707070',
    sourcePath: '/files/*.pdf',
    targetLocation: '66666666-6666-6666-6666-666666666666',
    targetPath: '/archive/pnc/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 6 * * 1',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_PAUSED,
    lastExecutionTime: '2024-02-12T06:00:00Z',
    createTime: '2024-01-05T12:00:00Z',
    updateTime: '2024-02-15T14:00:00Z',
  },
  {
    name: 'scheduledDeliveries/68d9e0f1-c2b3-4567-1234-890123456789',
    uid: '68d9e0f1-c2b3-4567-1234-890123456789',
    displayName: 'Goldman Sachs Data Feed',
    sourceLocation: '11111111-1111-1111-1111-111111111111',
    sourcePath: '/feeds/*.json',
    targetLocation: '33333333-3333-3333-3333-333333333333',
    targetPath: '/imports/gs/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '*/30 * * * *',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T10:30:00Z',
    lastExecutionTime: '2024-01-15T10:00:00Z',
    createTime: '2024-01-02T09:00:00Z',
    updateTime: '2024-02-20T11:00:00Z',
  },
  {
    name: 'scheduledDeliveries/79e0f1a2-d3c4-5678-2345-901234567890',
    uid: '79e0f1a2-d3c4-5678-2345-901234567890',
    displayName: 'Morgan Stanley EOD',
    sourceLocation: '55555555-5555-5555-5555-555555555555',
    sourcePath: '/eod/*.dat',
    targetLocation: '88888888-8888-8888-8888-888888888888',
    targetPath: '/feeds/ms/',
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_CRON,
      expression: '0 18 * * 1-5',
      timezone: 'America/New_York',
    },
    state: ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE,
    nextExecutionTime: '2024-01-15T18:00:00Z',
    lastExecutionTime: '2024-01-12T18:00:00Z',
    createTime: '2024-01-10T10:00:00Z',
    updateTime: '2024-02-22T14:00:00Z',
  },
];
